/**
 * formatRelative(iso) -> "3 months ago" | "12s ago" | "in 4 days" | "just now"
 *
 * Hand-rolled with Intl.RelativeTimeFormat — no moment/dayjs dependency.
 * Returns "—" for null/undefined/unparseable input so callers can render
 * a stable placeholder without a null-guard at every call site.
 */
export function formatRelative(iso, { locale = "en", now = Date.now() } = {}) {
  if (!iso) return "—";
  const t = typeof iso === "number" ? iso : Date.parse(iso);
  if (Number.isNaN(t)) return "—";
  const diffSec = Math.round((t - now) / 1000);
  const abs = Math.abs(diffSec);

  const fmt = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  if (abs < 45) return diffSec === 0 ? "just now" : fmt.format(diffSec, "second");
  if (abs < 90 * 60) return fmt.format(Math.round(diffSec / 60), "minute");
  if (abs < 22 * 3600) return fmt.format(Math.round(diffSec / 3600), "hour");
  if (abs < 26 * 86400) return fmt.format(Math.round(diffSec / 86400), "day");
  if (abs < 320 * 86400) return fmt.format(Math.round(diffSec / (30 * 86400)), "month");
  return fmt.format(Math.round(diffSec / (365 * 86400)), "year");
}

export function formatIso(iso) {
  if (!iso) return "";
  const d = typeof iso === "number" ? new Date(iso) : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString();
}
